import { useAppSelector } from '../../../app/store/hooks/Redux'
import { useEffect } from 'react'
import { usePostSiteLogoutMutation } from '../../../app/api'

export const useAuth = () => {
  const [triggerLogout] = usePostSiteLogoutMutation()

  const authenticated = useAppSelector((state) => state.root.auth.authenticated)

  useEffect(() => {
    if (authenticated !== null && !authenticated) {
      window.location.reload()
    }
  }, [authenticated])

  const logout = () => {
    triggerLogout().then(() => {
      window.cioanalytics?.reset()
      localStorage.removeItem('cio-identify')

      window.location.reload()
    })
  }

  return { logout }
}
